import { writable } from 'svelte/store';

const user = writable({
    authenticated: false
});

const userStore = {
    subscribe: user.subscribe,
    set: user.set,
    clear: () => {
        user.set({
            authenticated: false
        });
    }
}
export default userStore;
